module.exports = __webpack_public_path__ + "static/media/default-avatar.59337bae.png";